import { ProfileType } from '../types'
import { AssessmentStages, PracticeAssessmentStages } from '../types/assessments'
import { UserRole } from '../types/users/role'

export const assessmentStageKeys: AssessmentStages = [
  'Inquiry',
  'Authorization',
  'Consent Forms',
  'Send Claim',
  'Claims',
  'Complaints',
  'Complete',
]

export const practiceAssessmentStageKeys: PracticeAssessmentStages = [
  'Inquiry',
  'Current',
  'Postpartum',
  'Gyn',
  'Other',
  'Complete',
  'Discharged',
]

export const adminRoles: Array<UserRole> = ['admin', 'super-admin', 'lead-admin']
export const leadAdminRoles: Array<UserRole> = ['lead-admin', 'super-admin']
export const practiceAdminRoles: Array<UserRole> = ['admin', 'super-admin']

export const userAccess: UserRole[] = ['user', 'admin', 'super-admin', 'lead-admin']
export const adminAccess: UserRole[] = ['admin', 'super-admin', 'lead-admin']
export const leadAdminAccess: UserRole[] = ['lead-admin']
export const superAdminAccess: UserRole[] = ['super-admin']
export const profileTypes: ProfileType[] = ['pregnancy', 'gyn'] //| 'office-visit'
